import React from "react";
import spinner from "../../assets/images/loadingLogo.svg"
import "./Services.scss";

const Snipper = () => {

    return (
        <section className="spinner">
            <img className="spinner__img" src={spinner} alt="arian spinner logo" />
        </section>
    )

}

export default Snipper;